import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../../nav_bar/Navbar";
import Footer from "../../footer/Footer";
import { fetchTongueTwisterList } from "./tongueTwisterService";
import { BASE_ROOT } from "../../../../common/api_constant";
import "./TongueTwisterPage.css";

const difficultyOptions = ["EASY", "MEDIUM", "HARD"];

const TongueTwisterPage = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [difficulty, setDifficulty] = useState("");
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const navigate = useNavigate();

  const loadItems = useCallback(async () => {
    setLoading(true);
    console.log("[TongueTwister] BASE_ROOT:", BASE_ROOT);
    const res = await fetchTongueTwisterList({
      page,
      size: 20,
      difficulty: difficulty || undefined,
    });
    console.log("[TongueTwister] API result:", res);
    if (res.status === 200 && res.data?.status) {
      const data = res.data.data || [];
      console.log("[TongueTwister] items sample:", data.slice(0, 2).map(t => ({ id: t.id, title: t.title, imageUrl: t.imageUrl })));
      setItems(data);
      setTotalPages(res.data.totalPages || 0);
      setTotalItems(res.data.totalItems || 0);
    } else {
      setItems([]);
      setTotalPages(0);
      setTotalItems(0);
    }
    setLoading(false);
  }, [page, difficulty]);

  useEffect(() => {
    loadItems();
  }, [loadItems]);

  const difficultyColor = (d) => {
    const map = { EASY: "#4caf50", MEDIUM: "#ff9800", HARD: "#e91e63" };
    return map[d?.toUpperCase()] || "#999";
  };

  return (
    <>
      <Navbar />
      <div className="tt-page">
        <h1 className="tt-title">👅 Tongue Twisters</h1>
        <p className="tt-subtitle">
          Practice tricky phrases to improve your pronunciation and fluency.
        </p>

        <div className="tt-filters">
          <select
            className="tt-filter-select"
            value={difficulty}
            onChange={(e) => {
              setPage(0);
              setDifficulty(e.target.value);
            }}
          >
            <option value="">All Levels</option>
            {difficultyOptions.map((opt) => (
              <option key={opt} value={opt}>
                {opt.charAt(0) + opt.slice(1).toLowerCase()}
              </option>
            ))}
          </select>
        </div>

        {totalItems > 0 && (
          <p className="tt-count">{totalItems} tongue twisters found</p>
        )}

        {loading ? (
          <p className="tt-loading">Loading...</p>
        ) : items.length === 0 ? (
          <p className="tt-empty">No tongue twisters found.</p>
        ) : (
          <div className="tt-grid">
            {items.map((t) => (
              <div
                key={t.id}
                className="tt-card"
                onClick={() => navigate(`/study/tongue-twisters/${t.id}`)}
              >
                {t.imageUrl && (
                  <img
                    src={`${BASE_ROOT}${t.imageUrl}`}
                    alt={t.title}
                    onLoad={() => console.log("[TongueTwister] Image OK:", `${BASE_ROOT}${t.imageUrl}`)}
                    onError={() => console.error("[TongueTwister] Image FAIL:", `${BASE_ROOT}${t.imageUrl}`)}
                    style={{ width: "calc(100% + 40px)", height: 130, objectFit: "contain", background: "#f5f5f5", borderRadius: "16px 16px 0 0", margin: "-20px -20px 14px -20px", display: "block" }}
                  />
                )}
                <div className="tt-card-header">
                  <h3 className="tt-card-title">{t.title}</h3>
                  <span
                    className="tt-difficulty"
                    style={{ background: difficultyColor(t.difficulty) }}
                  >
                    {t.difficulty}
                  </span>
                </div>
              </div>
            ))}
          </div>
        )}

        {totalPages > 1 && (
          <div className="tt-pagination">
            <button disabled={page === 0} onClick={() => setPage(page - 1)}>
              ← Prev
            </button>
            <span>
              Page {page + 1} / {totalPages}
            </span>
            <button
              disabled={page + 1 >= totalPages}
              onClick={() => setPage(page + 1)}
            >
              Next →
            </button>
          </div>
        )}
      </div>
      <Footer />
    </>
  );
};

export default TongueTwisterPage;
